import { Component, ElementRef, Inject, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import moment from 'moment';
import { LogTrackingService } from '../log-tracking.service';
import { NgxSpinner, NgxSpinnerService } from 'ngx-spinner';
import { DialogDeleteFilterComponent } from '../dialog-delete-filter/dialog-delete-filter.component';
import { MatDateRangePicker } from '@angular/material/datepicker';

@Component({
  selector: 'app-log-track-dialog',
  templateUrl: './log-track-dialog.component.html',
  styleUrls: ['./log-track-dialog.component.scss']
})
export class LogTrackDialogComponent implements OnInit {

  // @ViewChild('searchInputcampus') searchInputcampus!: ElementRef;
  @ViewChildren('searchInputcampus') searchInputcampus!: QueryList<ElementRef>;

  @ViewChild('picker') picker!: MatDateRangePicker<Date>;

  campusQuery: string[] = [];
  startDate: any;
  endDate: any;
  selectedOne: any;
  selectedColumn: any
  selectAll: boolean[] = [];
  selectedName: any;

  subjectWise: any = [
    {
      searchFilterDataKey: '',
      searchFilterDataValues: [],
    },
  ];

  isDropdownDisabled = true;
  isAddDisabled = true;
  subjectDetails: any = [];
  filterListDetails: any;
  filterKeyList: any;
  userList: any;
  filteredDetails: any;
  filterdetails: any;
  flt: any;
  selectedOption: string = '';
  // selected: string[] = ['Select all']
  selectedVisitDateOption: string[] = [];
  searchFilterList: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<LogTrackDialogComponent>, private log: LogTrackingService, private spinner: NgxSpinnerService, private dialog: MatDialog) { }
  ngOnInit(): void {
    this.filterList();
  }

  // DROPDOWN RESPONSE //

  filterList() {
    this.spinner.show();
    this.log.getfilter().subscribe(
      {
        next: (res: any) => {
          this.filterListDetails = res;
          console.log('filterListDetails', this.filterListDetails);
          this.spinner.hide();
        },
        error: (err: any) => {
          this.spinner.hide();
        }
      }
    )
  }

  // DIALOG CLOSE //

  close() {
    this.dialogRef.close();
  }

  closeFilter() {
    this.dialogRef.close();
  }


  onSubjectSelect(event: any, index: any) {
    const selectedSubject = event.target.value;
    this.subjectWise[index].searchFilterDataValues = [];
    this.isColumnDisabled(this.subjectWise[index].searchFilterDataKey);
    this.isDropdownDisabled = false;
    this.getFilterKeyDetails(selectedSubject, index);
  }

  // DISABLE THE DROPDOWN SELECTED ONE//

  isColumnDisabled(searchFilterDataKey: any) {
    if (this.subjectWise.some((rows: any) => rows.searchFilterDataKey === searchFilterDataKey)) {
      return true;
    }
    return this.isUserIdUserNameMutuallyDisabled(searchFilterDataKey);
  }

  /** User Id and User Name cannot both be used as filters at the same time. */
  private isUserIdUserNameMutuallyDisabled(searchFilterDataKey: string): boolean {
    const userIdKey = this.getUserIdFilterKey();
    const userNameKey = this.getUserNameFilterKey();
    if (!userIdKey || !userNameKey || userIdKey === userNameKey) {
      return false;
    }
    const selectedKeys = this.subjectWise
      .map((row: any) => row.searchFilterDataKey)
      .filter((key: string) => !!key);
    if (selectedKeys.includes(userIdKey) && searchFilterDataKey === userNameKey) {
      return true;
    }
    if (selectedKeys.includes(userNameKey) && searchFilterDataKey === userIdKey) {
      return true;
    }
    return false;
  }

  private getUserIdFilterKey(): string | null {
    return this.findFilterKeyByLabel('user id');
  }

  private getUserNameFilterKey(): string | null {
    return this.findFilterKeyByLabel('user name');
  }

  private findFilterKeyByLabel(label: string): string | null {
    const normalizedLabel = label.trim().toLowerCase();
    const match = (this.filterListDetails ?? []).find((item: any) => {
      const display = String(item?.filterDataValue ?? '').trim().toLowerCase();
      const member = String(item?.filterDataMember ?? '').trim().toLowerCase();
      return display === normalizedLabel || member === normalizedLabel.replace(/\s+/g, '_') || member === normalizedLabel.replace(/\s+/g, '');
    });
    return match?.filterDataMember ?? null;
  }



  // SECOND CHECKBOXS RESPONSE //

  getFilterKeyDetails(selectedSubject: any, index: any) {
    this.spinner.show();
    this.log.getFilterKey(selectedSubject).subscribe(
      {
        next: (res: any) => {
          this.subjectWise[index].filterdetails = res;
          console.log('filterKeyList', this.subjectWise[index].filterdetails);
          this.subjectWise[index].flt = this.subjectWise[index].filterdetails;
          this.filteredDetails = res;
          this.filterKeyList = res;
          this.spinner.hide();
        },
        error: (err: any) => {
          this.spinner.hide();
        }
      }
    )
  }

  // SELETE ALL CHECKBOX FUNCTION //

  toggleSelectAll(i: number) {
    if (this.selectAll[i]) {
      // Select all facultyIds
      this.subjectWise[i].searchFilterDataValues = this.subjectWise[i].filterdetails.map((d: any) => d.userValue);
      this.subjectWise[i].filterdetails.forEach((d: any) => d.selected = true);
    } else {
      // Unselect all
      this.subjectWise[i].searchFilterDataValues = [];
      this.subjectWise[i].filterdetails.forEach((d: any) => d.selected = false);
    }
  }

  // FOCUS THE SEARCH INPUT //

  focusSearchInput(index: any) {
    // if (this.searchInputcampus) {
    //   this.searchInputcampus.nativeElement.focus(); 
    // }

    this.campusQuery[index] = ''; // Clear the query text

    // Refresh the full list (unfiltered)
    const allItems = this.subjectWise[index].filterdetails;
    this.subjectWise[index].flt = [...allItems];

    // Focus the input after view updates
    setTimeout(() => {
      const input = this.searchInputcampus.toArray()[index];
      if (input) {
        input.nativeElement.focus();
      }
    });
  }

  // SEARCH LIST FUNCTION //

  campusSearch(event: Event, i: number) {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
    const allItems = this.subjectWise[i].filterdetails;
    this.subjectWise[i].flt = searchTerm
      ? allItems.filter((item: any) =>
        item.userValue.toLowerCase().includes(searchTerm)
      )
      : [...allItems];

  }

  // CHECKED ALL FUNCTION //

  onFacultySelect(event: any, index: number) {
    const filterId = event.target.value;
    const checked = event.target.checked;

    this.isAddDisabled = false;
    if (!this.subjectWise[index].searchFilterDataValues) {
      this.subjectWise[index].searchFilterDataValues = [];
    }
    if (checked) {
      // Add to list
      this.subjectWise[index].searchFilterDataValues.push(filterId);

      console.log('add it', this.subjectWise[index].searchFilterDataValues);
    } else {
      // Remove from list
      this.subjectWise[index].searchFilterDataValues = this.subjectWise[index].searchFilterDataValues.filter((id: number) => id !== filterId);
      console.log('remove', this.subjectWise[index].searchFilterDataValues)
    }
    this.isAnyFacultySelected
  }

  // ROW IS EMPTY ADD BUTTON NOT TRIGER //

  isRowEmpty(index: number) {
    const rows = this.subjectWise[index];
    console.log('row', rows)
    if (rows.searchFilterDataValues == '') {
      return true;
    } else {
      return false;
    }
  }

  // STATIC LIST DATE RANGE //

  radioOptions = [
    { id: 'last7', value: 'Last_7', label: 'Last 7 days' },
    { id: 'last15', value: 'Last_15', label: 'Last 15 days' },
    { id: 'currentWeek', value: 'Current_Week', label: 'Current Week' },
    { id: 'previousWeek', value: 'Previous_Week', label: 'Previous Week' },
    { id: 'currentMonth', value: 'Current_Month', label: 'Current Month' },
    { id: 'previousMonth', value: 'Previous_Month', label: 'Previous Month' },
    { id: 'customRange', value: 'Custom_Range', label: 'Custom Range' },
  ];

  // CUSTOM DATE RANGE //

  onVistTimeRadio(selectedValue: any, index: number) {
    this.selectedVisitDateOption[index] = selectedValue;
    console.log('radio value:', selectedValue);
    console.log('Selected radio value:', selectedValue);
    if (!this.subjectWise[index].searchFilterDataValues) {
      this.subjectWise[index].searchFilterDataValues = [];
    }
    if (selectedValue === 'Custom_Range') {
      setTimeout(() => { this.picker.open(); }, 0);
      console.log('Custom Range selected, not updating searchFilterDataValues');
      this.onDateChange(index);
      return; // Skip updating
    }
    else if (selectedValue !== 'Custom_Range') {
      this.subjectWise[index].searchFilterDataValues = {
        rangeType: this.selectedVisitDateOption[index]
      }
      console.log('Updated searchFilterDataValues:', this.subjectWise[index].searchFilterDataValues);
    }
  }

  // onVistTimeRadio(selectedValue: any, index: number) {
  //   console.log('Selected radio value:', selectedValue);

  //   if (!this.subjectWise[index].searchFilterDataValues) {
  //     this.subjectWise[index].searchFilterDataValues = {};
  //   }

  //   if (selectedValue === 'Custom_Range') {
  //     setTimeout(() => { this.picker.open(); }, 0);
  //     console.log('Custom Range selected, waiting for user to pick dates');
  //     return;
  //   }

  //   // Set dates based on the selected option
  //   let start: moment.Moment;
  //   let end: moment.Moment;
  //   const today = moment();

  //   switch (selectedValue) {
  //     case 'Last_7':
  //       start = today.clone().subtract(6, 'days');
  //       end = today;
  //       break;
  //     case 'Last_15':
  //       start = today.clone().subtract(14, 'days');
  //       end = today;
  //       break;
  //     case 'Current_Week':
  //       start = today.clone().startOf('week');
  //       end = today.clone().endOf('week');
  //       break;
  //     case 'Previous_Week':
  //       start = today.clone().subtract(1, 'week').startOf('week');
  //       end = today.clone().subtract(1, 'week').endOf('week');
  //       break;
  //     case 'Current_Month':
  //       start = today.clone().startOf('month');
  //       end = today.clone().endOf('month');
  //       break;
  //     case 'Previous_Month':
  //       start = today.clone().subtract(1, 'month').startOf('month');
  //       end = today.clone().subtract(1, 'month').endOf('month');
  //       break;
  //     default:
  //       start = end = today;
  //   }

  //   this.subjectWise[index].searchFilterDataValues = {
  //     startDate: start.format("DD-MMM-YYYY"),
  //     endDate: end.format("DD-MMM-YYYY"),
  //   };

  //   console.log('Updated searchFilterDataValues:', this.subjectWise[index].searchFilterDataValues);
  // }


  onDateChange(index: any) {
    if (this.startDate && this.endDate) {
      console.log('Start Date:', this.startDate);
      console.log('End Date:', this.endDate);
    }
    this.subjectWise[index].searchFilterDataValues = {
      rangeType: this.selectedVisitDateOption[index],
      startDate: moment(this.startDate).format("DD-MMM-YYYY"),
      endDate: moment(this.endDate).format("DD-MMM-YYYY")
    }
    console.log('Date of end', this.subjectWise[index].searchFilterDataValues);

  }
  onPrevious(index: any) {
    this.subjectWise[index].searchFilterDataValues = {
      rangeType: this.selectedVisitDateOption[index],
    }
  }

  // ADD THE ROW //

  addSelected() {
    this.subjectWise.push({
      searchFilterDataKey: '',
      searchFilterDataValues: [],
    });
    // Clear all existing search inputs
    this.campusQuery = this.subjectWise.map(() => '');
    console.log('campusQuery', this.campusQuery);
    console.log('rowadded', this.subjectWise)
  }

  // DELETE THE ROW //

  deleteLowPerformanceFields(index: any) {
    console.log('val', this.subjectWise[index]);
    const dialog = this.dialog.open(DialogDeleteFilterComponent, {
      width: '300px',
      position: { right: '200px' },

    });
    dialog.afterClosed().subscribe((result) => {
      if (result === 'delete') {
        console.log('Remove_Row', this.subjectWise)
        this.subjectWise.splice(index, 1);
      }
    })
  }



  isAnyFacultySelected(index: number): boolean {
    return this.subjectWise[index]?.flt?.some((item: any) => item.selected);
  }



  // isAddEnabled(index: number): boolean {
  //   const subject = this.subjectWise[index];
  //   console.log('subject', subject)

  //   if (!subject || !subject.searchFilterDataKey) return false;

  //   // Case 1: VISIT_DATE_TIME — must have startDate & endDate
  //   if (subject.searchFilterDataKey === 'VISIT_DATE_TIME') {
  //     return !!(subject.searchFilterDataValues?.startDate && subject.searchFilterDataValues?.endDate);

  //   }

  //   // Case 2: searchFilterDataValues is a non-empty array (predefined value selected)

  //   if (Array.isArray(subject.searchFilterDataValues) && subject.searchFilterDataValues.length > 0) {
  //     return true;
  //   }

  //   // Case 3: Checkbox selections — check if at least one is selected
  //   return subject.flt?.some((item: any) => item.selected);
  // }

  // button Enable in filter //

  // isAddEnabled(index: number): boolean {
  //   const subject = this.subjectWise[index];
  //   if (!subject || !subject.searchFilterDataKey) return false;

  //   if (subject.searchFilterDataKey === 'VISIT_DATE_TIME') {
  //     const values = subject.searchFilterDataValues;

  //     if (values && typeof values === 'object' && 'startDate' in values && 'endDate' in values) {
  //       return !!(values.startDate && values.endDate);
  //     }

  //     if (Array.isArray(values) && values.length === 1 && typeof values[0] === 'string') {
  //       return true;
  //     }

  //     return false;
  //   }

  //   if (Array.isArray(subject.searchFilterDataValues) && subject.searchFilterDataValues.length > 0) {
  //     return true;
  //   }

  //   // Case 3: Checkbox selections — check if at least one is selected

  //   return subject.flt?.some((item: any) => item.selected);
  // }

  isAddEnabled(index: number): boolean {
    const subject = this.subjectWise[index];
    if (!subject || !subject.searchFilterDataKey) return false;

    if (subject.searchFilterDataKey === 'VISIT_DATE_TIME') {
      const values = subject.searchFilterDataValues;

      if (values && typeof values === 'object') {
        if ('startDate' in values && 'endDate' in values) {
          // Case: Custom range
          return !!(values.startDate && values.endDate);
        }

        if ('rangeType' in values && typeof values.rangeType === 'string') {
          // Case: Predefined range like 'Today', 'Yesterday', etc.
          return true;
        }
      }

      return false;
    }

    // Non-VISIT_DATE_TIME cases
    if (Array.isArray(subject.searchFilterDataValues) && subject.searchFilterDataValues.length > 0) {
      return true;
    }

    // Checkbox-based filter case
    return subject.flt?.some((item: any) => item.selected);
  }

  // SAVE ALL DETAILS //

  apply() {
    this.subjectWise = this.subjectWise.map((item: any) => {
      delete item.filterdetails;
      delete item.flt;
      return item;
    });
    console.log('save', this.subjectWise);
   
    this.dialogRef.close(this.subjectWise);

  }



}